module.exports = __webpack_public_path__ + "static/img/line.3df0174.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/line.png
// module id = La/J
// module chunks = 7